// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.socialProofing_socialProofing__FPNwS {
  width: 100%;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.socialProofing_textContainer__aqHrm {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  gap: 4px;
  font-size: 12px;
  line-height: 16px;
}

.socialProofing_parentText__xoPMj {
  font-family: 'Noto Sans', sans-serif;
  color: #ffffff;
}

.socialProofing_placeholderText__47Zx2 {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  display: inline-block;
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/SocialProofing/socialProofing.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".socialProofing {\n  width: 100%;\n  padding: 12px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.textContainer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n  text-align: center;\n  gap: 4px;\n  font-size: 12px;\n  line-height: 16px;\n}\n\n.parentText {\n  font-family: 'Noto Sans', sans-serif;\n  color: #ffffff;\n}\n\n.placeholderText {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 500;\n  display: inline-block;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"socialProofing": `socialProofing_socialProofing__FPNwS`,
	"textContainer": `socialProofing_textContainer__aqHrm`,
	"parentText": `socialProofing_parentText__xoPMj`,
	"placeholderText": `socialProofing_placeholderText__47Zx2`
};
export default ___CSS_LOADER_EXPORT___;
